import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initClarity } from './utils/clarity';

/**
 * Fonts are NOT loaded from here anymore.
 *
 * Oswald and Inter are declared with @font-face inside index.css, which the
 * served HTML links statically. The browser therefore discovers the woff2 URLs
 * on its first parse — no fonts.googleapis.com stylesheet round-trip, and no
 * JS-injected <link rel="preload">, which fired far too late (~1431ms) to help.
 *
 * All this file still does is clean up any foreign Google Fonts stylesheet
 * (Poppins, the Inter variable axis build, ...) that something else injects.
 */
function dropForeignFontSheets() {
  document.head.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"][href*="fonts.googleapis.com"]').forEach(sheet => sheet.remove());
}
dropForeignFontSheets();
window.addEventListener('load', dropForeignFontSheets, {
  once: true
});

// Clarity goes up immediately, before render, so it captures the first frame.
initClarity();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-290" data-mp="15p85hhqr07fy" />);
}